import { useState, Fragment } from "react";
import {
    TableBody
} from "@mui/material";
import { TableViews } from "./TableViews";


const DataTable = ({
    claimRecord, setClaimRecord
}) => {
    const [editState, setEditState] = useState({
        id:null,
        status:false
    })

    return (
        <TableBody>
            {claimRecord && claimRecord.map((row, idx) => (
                <Fragment key={idx}>
                    <TableViews
                        row={row}
                        idx={idx}
                        setClaimRecord={setClaimRecord}
                        editState={editState}
                        setEditState={setEditState}
                    />
                </Fragment>
            ))}
        </TableBody>
    )
}

export default DataTable;